import appStarterFactory from 'bundles/page/lib/appStarterFactory';
import appEnv from 'bundles/promo-template/appEnv';

export default appStarterFactory(appEnv);
